import { Capacitor } from '@capacitor/core';
import { App } from '@capacitor/app';
import { APP_VERSION } from './appVersion';

let infoPromise: Promise<Awaited<ReturnType<typeof App.getInfo>>> | undefined;
export async function nativeRequestInfo(): Promise<Record<string, string>> {
  const platform = Capacitor.getPlatform?.();
  if (!Capacitor.isNativePlatform() || (platform !== 'android' && platform !== 'ios')) return {};
  // Ein vorübergehender Bridge-Fehler darf spätere Requests nicht dauerhaft entwerten.
  try {
    const info = await (infoPromise ??= App.getInfo());
    return { 'x-lorath-platform': platform, 'x-lorath-app-id': info.id,
      'x-lorath-wrapper-ver': info.version, 'x-lorath-native-build': info.build,
      'x-lorath-bundle-ver': APP_VERSION };
  } catch { infoPromise = undefined; return {}; }
}
